
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "32px",
    "height": "32px",
    "viewBox": "0 0 32 32",
    "enable-background": "new 0 0 32 32",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "currentColor",
        "width": "32",
        "height": "32"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "currentColor",
        "d": "M8.548,26C7.144,26,6,24.925,6,23.602V8.396C6,7.075,7.144,6,8.548,6h9.738c0.457,0,0.828,0.344,0.828,0.769\n\tc0,0.424-0.371,0.771-0.828,0.771H9.119c-0.806,0-1.463,0.627-1.463,1.4v14.12c0,0.775,0.657,1.403,1.463,1.403h12.604\n\tc0.809,0,1.464-0.628,1.464-1.403v-6.166l0.003-0.317c-0.003-0.458,0.369-0.801,0.826-0.801s0.829,0.343,0.829,0.769l-0.023,0.338\n\tl0.023,0.001v6.719c0,1.323-1.144,2.398-2.548,2.398H8.548z M11.974,21.106c-0.223,0-0.434-0.084-0.59-0.233\n\tc-0.154-0.144-0.238-0.334-0.238-0.536s0.084-0.393,0.236-0.538L24.579,7.29c0.156-0.147,0.367-0.229,0.592-0.229\n\tc0.223,0,0.435,0.081,0.592,0.23C25.915,7.436,25.999,7.626,26,7.828c0,0.203-0.085,0.394-0.237,0.539L12.566,20.873\n\tC12.41,21.022,12.198,21.106,11.974,21.106z"
      }
    }
  ]
})
    }
  